import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Box } from '../Box';
import { shimmer } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var ShimmerBox = function ShimmerBox(props) {
  var _props$width = props.width,
      width = _props$width === void 0 ? '100%' : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? 18 : _props$height;
  return ___EmotionJSX(Box, _extends({
    css: shimmer,
    width: width,
    height: height
  }, props));
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21tb24vU2hpbW1lckJveC9pbmRleC50c3giXSwibmFtZXMiOlsiUmVhY3QiLCJCb3giLCJzaGltbWVyIiwiU2hpbW1lckJveCIsInByb3BzIiwid2lkdGgiLCJoZWlnaHQiXSwibWFwcGluZ3MiOiI7Ozs7QUFBQSxPQUFPQSxLQUFQLE1BQWtCLE9BQWxCO0FBQ0EsU0FBU0MsR0FBVCxRQUEyQixRQUEzQjtBQUNBLFNBQVNDLE9BQVQsUUFBd0IsVUFBeEI7O0FBRUEsT0FBTyxJQUFNQyxVQUEyQixHQUFHLFNBQTlCQSxVQUE4QixDQUFBQyxLQUFLLEVBQUk7QUFBQSxxQkFDVkEsS0FEVSxDQUMxQ0MsS0FEMEM7QUFBQSxNQUMxQ0EsS0FEMEMsNkJBQ2xDLE1BRGtDO0FBQUEsc0JBQ1ZELEtBRFUsQ0FDMUJFLE1BRDBCO0FBQUEsTUFDMUJBLE1BRDBCLDhCQUNqQixFQURpQjtBQUVsRCxTQUFPLGNBQUMsR0FBRDtBQUFLLElBQUEsR0FBRyxFQUFFSixPQUFWO0FBQW1CLElBQUEsS0FBSyxFQUFFRyxLQUExQjtBQUFpQyxJQUFBLE1BQU0sRUFBRUM7QUFBekMsS0FBcURGLEtBQXJELEVBQVA7QUFDRCxDQUhNIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IEJveCwgUHJvcHMgfSBmcm9tICcuLi9Cb3gnO1xuaW1wb3J0IHsgc2hpbW1lciB9IGZyb20gJy4vc3R5bGVzJztcblxuZXhwb3J0IGNvbnN0IFNoaW1tZXJCb3g6IFJlYWN0LkZDPFByb3BzPiA9IHByb3BzID0+IHtcbiAgY29uc3QgeyB3aWR0aCA9ICcxMDAlJywgaGVpZ2h0ID0gMTggfSA9IHByb3BzO1xuICByZXR1cm4gPEJveCBjc3M9e3NoaW1tZXJ9IHdpZHRoPXt3aWR0aH0gaGVpZ2h0PXtoZWlnaHR9IHsuLi5wcm9wc30+PC9Cb3g+O1xufTtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./~/@utex/ui-kit/dist/common/ShimmerBox/index.js
// module id = 1669
// module chunks = 118